/* Component Dependencies */
var $ = require('jquery');
var eventProfileFormTemplate = require('templates/eventProfileForm.hbs');
var eventProfileFormIrfpTemplate = require('templates/eventProfileForm-irfp.hbs');
var AriesComponent = require('libs/aries-component');
var PubSub = require('libs/pub-sub');
var DateHandler = require('libs/date-handler');
var Constants = require('libs/constants');
var ResponsiveUtils = require('utils/responsiveUtils');
var utils = require('../../libs/utils');

AriesComponent.create({
	type: 'eventProfileForm',
	template: {
		'eventProfileForm': eventProfileFormTemplate,
		'eventProfileForm-irfp': eventProfileFormIrfpTemplate
	},
	formData: {
		endDate: '',
		startDate: '',
		name: '',
		flexibleDate: 'No',
		eventType: '',
		customEventType: '',
		attendees: '',
		numberOfRooms: ''
	},
	budgetData: {
		budget: '',
		currency: ''
	},
	eventProfileData: {},
	bindEvents: function() {
		var _self = this,
			$element = this.$el.find('.js-positive-number');
		_self.initResponsiveUtils();
		_self.initDateHandler();
		_self.handleEventProfileFormResize();
		_self.setDefaultData();
		_self.handleTabIndex();
		_self.alignInputFields();
		_self.realignInputFields();
		_self.toggleOverLay();
		_self.budgetData.currency = $('.event-type option:selected').text();
		delete _self.formData.budget;
		$(document).ready(function() {
			_self.pubsub.publish('UPDATE_FORM_DATA', ['eventProfileDetails', _self.formData]);
			_self.pubsub.publish('UPDATE_FORM_DATA', ['eventBudgetDetails', _self.budgetData]);
		});
		_self.eventNameRegex = new RegExp('^[a-zA-Z0-9]+$');
		utils.validation.positiveNumber($element);
	},
	events: {
		'blur input[type="text"],input[type="number"]': 'publishDataToSubmit',
		'change input[type="radio"]': 'publishDataToSubmit',
		'change .js-event-space': 'updateSquareFootage',
		'keyup .js-toggle-attendees': 'toggleOverLay',
		'blur #budget' : 'getBudgetInfo'
	},
	/**
   * Getting currency type and Budget.
   */
	getBudgetInfo: function _getBudgetInfo() {
		var _self = this;
		_self.budgetData.currency = $('.event-type option:selected').text();
		_self.budgetData.budget = $('#budget').val();
		_self.pubsub.publish('UPDATE_FORM_DATA', ['eventBudgetDetails', _self.budgetData]);
	},
	setDefaultData: function _setDefaultData() {
		var _self = this;
		this.$el.find('input').each(function() {
			_self.fetchData(null, $(this)[0]);
		});
	},

	fetchData: function _fetchData(event, currentElement) {
		var _self = this,
			currentElement = event ? event.target : currentElement,
			elementType = event ? event.target.type : currentElement.type,
			otherEventType = _self.$el.find('.l-other-option'),
			otherEventInput = _self.$el.find('.l-other-event-description'),
			endDateEle = _self.$el.find('[name=toDate]'),
			startDateEle = _self.$el.find('[name=fromDate]'),
			startDateSelected = _self.$el.find('.js-date-from'),
			endDateSelected = _self.$el.find('.js-date-to');
		switch (elementType) {
			case 'text':
				if ($(currentElement).hasClass('js-date-to') || $(currentElement).hasClass('js-date-from')) {
					_self.formData['startDate'] = startDateEle.val();
					_self.formData['endDate'] = endDateEle.val();
					_self.eventProfileData['startDate'] = startDateSelected.val();
					_self.eventProfileData['endDate'] = endDateSelected.val();

				} else if ($(currentElement).hasClass('js-positive-number')) {
					if (currentElement.value != '') {
						currentElement.value = parseInt(currentElement.value);
						_self.formData[currentElement.name] = currentElement.value;
						_self.eventProfileData[currentElement.name] = currentElement.value;
					} else {
						_self.eventProfileData[currentElement.name] = 0;
						_self.formData[currentElement.name] = '';
					}
				} else {
					_self.formData[currentElement.name] = currentElement.value;
					_self.eventProfileData[currentElement.name] = currentElement.value;
				}
				break;

			case 'radio':
				_self.formData[currentElement.name] = currentElement.checked ? currentElement.value : _self.formData[currentElement.name];
				if (currentElement.checked && currentElement.name === otherEventType.attr('name')) {
					_self.eventProfileData[currentElement.name] = currentElement.value;
					if (_self.$el.find(currentElement).hasClass('l-other-option')) {
						otherEventInput.removeClass('is-hidden');
					} else {
						otherEventInput.addClass('is-hidden');
					}
				} else if (currentElement.name === 'flexibleDate' && currentElement.checked) {
					currentElement.value === 'Yes' ?
						_self.eventProfileData['flexibleDateTrue'] = true : _self.eventProfileData['flexibleDateTrue'] = false;
				}
				break;

			case 'number':
				_self.formData[currentElement.name] = currentElement.value;
				if (currentElement.value) {
					_self.eventProfileData[currentElement.name] = currentElement.value;
				} else {
					_self.eventProfileData[currentElement.name] = 0;
				}
				break;
		}
	},
	publishDataToSubmit: function _publishDataToSubmit(event) {
		event.stopPropagation();
		var _self = this;
		if (event) {
			this.fetchData(event);
			delete _self.formData.budget;
			this.pubsub.publish('UPDATE_FORM_DATA', ['eventProfileDetails', this.formData]);
			this.pubsub.publish('UPDATE_FORM_DATA', ['eventBudgetDetails', _self.budgetData]);
			this.pubsub.publish('UPDATE_EVENT_SUMMARY', ['eventProfileDetails', _self.eventProfileData]);
		}
	},
	handleEventProfileFormResize: function() {
		var $body = $('body');
		if (this.responsiveUtils.isMobile() || this.responsiveUtils.isTablet()) {
			$body.addClass('is-form-takeover');
		} else {
			$body.removeClass('is-form-takeover');
		}
		this.dateHandler.pickaDatePlugin.handleFormat();
	},
	initResponsiveUtils: function() {
		this.responsiveUtils = ResponsiveUtils.create({
			isTakeOverRequired: false
		});
		this.responsiveUtils.init();
	},
	getTakeOverVariation: function() {
		return Constants.SEARCH_FORM.VARIATIONS.EDIT_SEARCH;
	},
	isAndroidDevice: function() {
		var ua = navigator.userAgent.toLowerCase();
		return ua.indexOf('android') > -1;
	},

	/**
	 * This function is used to handle tab indexes on Search Forms
	 */
	handleTabIndex: function() {
		var _self = this,
			i;
		var ele = ['.picker__nav--prev:not(.picker__nav--disabled)', '.picker__nav--next:not(.picker__nav--disabled)', '.js-date-clear', '#hotelFromDate', '#hotelToDate', '.flexible-date', '.l-event-type-options input:not(.l-other-option)', '#otherEventName', '#attendees', '#numberOfRooms'];
		_self.$el.find('#name').off().on('focus').attr('tabIndex', 0);
		_self.$el.find('#name').on('focusout').removeAttr('tabIndex');
		this.$el.find(ele.join(', ')).on('focus', function() {
			var tabIndex = 2;
			for (i in ele) {
				_self.$el.find(ele[i]).attr('tabIndex', tabIndex);
			}
		});
		this.$el.find(ele.join(', ')).on('focusout', function() {
			for (i in ele) {
				_self.$el.find(ele[i]).not('.picker__nav--prev:not(.picker__nav--disabled), .picker__nav--next:not(.picker__nav--disabled), .js-date-clear').removeAttr('tabIndex');
			}
		});
		this.$el.on('keydown', '.picker__nav--prev, .picker__nav--next', function(e) {
			if (e.keyCode === 13) {
				$(this).trigger('click');
				var tabIndex = $(this).attr('tabIndex');
				if ($(this).hasClass('picker__nav--next')) {
					_.delay(function() {
						var navEl = _self.$el.find('.picker__nav--next');
						navEl.attr('tabIndex', tabIndex);
						navEl.focus();
					}, 0);
				} else {
					_.delay(function() {
						var navEl = _self.$el.find('.picker__nav--prev');
						navEl.attr('tabIndex', tabIndex);
						navEl.focus();
					}, 0);
				}
			}
		});
	},
	updateSquareFootage: function _updateSquareFootage(event) {
		var eventSpace = parseInt($(event.target).val());
		var squareFootage = eventSpace * 10;
		if (eventSpace) {
			this.$el.find('.square-footage-label').removeClass('is-hidden');
			this.$el.find('.js-square-footage').removeClass('is-hidden').html(squareFootage);
		} else {
			this.$el.find('.square-footage-label').addClass('is-hidden');
			this.$el.find('.js-square-footage').addClass('is-hidden');
		}
	},
	toggleOverLay:function(event){
		var _self = this;
		var focus = _self.$el.find('.js-toggle-attendees').is(':focus');
		var eventSpace = parseInt(_self.$el.find('.js-toggle-attendees').val());
		if(eventSpace) {
			_self.$el.find('.l-input-overlay').removeClass('is-hidden');
		} else {
			_self.$el.find('.l-input-overlay').addClass('is-hidden')
		}
	},
	initDateHandler: function() {
		var _self = this;
		_self.dateHandler = new DateHandler({
			$el: this.$el.find('.js-datepick-container'),
			$parent: _self,
			addCustomHeaderStyle: true
		});
		_self.dateHandler.init();
	},
	realignInputFields:function(){
		var _self = this;
		$(window).on('resize orientationchange', _.debounce(_self.alignInputFields.bind(_self), 75));
	},
	alignInputFields:function(){
		var maxHeight = 0;
		var $formGroup = this.$el.find('.l-event-needs-main-container .l-form-group');
		var $formGroupContainer = this.$el.find('.l-event-needs-main-container .l-form-group .l-info-container');
		var eventNeedContainer= this.$el.find('.l-event-needs-container h3');
		var eventBugetContainer = this.$el.find('.l-event-budget-container h3');
		if(this.responsiveUtils.isMobile()){
			eventNeedContainer.css('height','inherit')
			eventBugetContainer.css('height','inherit')
		}else{
			var maxOf = Math.max(Math.floor(eventNeedContainer.outerHeight()), Math.floor(eventBugetContainer.outerHeight()));
			eventNeedContainer.outerHeight(maxOf);
			eventBugetContainer.outerHeight(maxOf);
		}
		$formGroupContainer.each(function() {
			maxHeight = parseFloat($(this).outerHeight()) > maxHeight ? parseFloat($(this).outerHeight()) : maxHeight;
		});
		$formGroup.each(function() {
			var diff = maxHeight - $(this).find('.l-info-container').outerHeight();
			$(this).css({'top': diff +'px'});
		})
	}

});
